import { render, staticRenderFns } from "./examMessageLook.vue?vue&type=template&id=38c14e1a&scoped=true"
import script from "./examMessageLook.vue?vue&type=script&lang=js"
export * from "./examMessageLook.vue?vue&type=script&lang=js"
import style0 from "./examMessageLook.vue?vue&type=style&index=0&id=38c14e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c14e1a",
  null
  
)

export default component.exports